type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const ParcelDetailStatus = Object.freeze({
  WAIT_INVOICE: 1 as const,
  CREATE_INVOICE: 2 as const,
  CANCEL: 3 as const,
});

export type ParcelDetailStatus = EnumLiteralsOf<typeof ParcelDetailStatus>;
